define.alias("shared/components/shared/ui/flash-message", "calendar/components/shared/ui/flash-message");